var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Type } from 'class-transformer';
import { ResourceCollection } from './ResourceCollection';
import { HttpExclude, RequestExpose, ResponseExpose } from '../../decorators';
var PageCollection = /** @class */ (function (_super) {
    __extends(PageCollection, _super);
    function PageCollection(classType) {
        var _this = _super.call(this, classType) || this;
        _this.search = null;
        _this.currentPage = PageCollection_1.defaultCurrentPage;
        _this.perPage = PageCollection_1.defaultPerPage;
        _this.orderBy = null;
        _this.asc = null;
        _this.items = [];
        _this.total = null;
        _this.addFilter(_this);
        return _this;
    }
    PageCollection_1 = PageCollection;
    Object.defineProperty(PageCollection.prototype, "isLastPage", {
        get: function () {
            var page = this.currentPage || 0;
            return page === this.lastPage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageCollection.prototype, "lastPage", {
        get: function () {
            return Math.floor(Math.max((this.total || 0) - 1, 0) / (this.perPage || 1));
        },
        enumerable: true,
        configurable: true
    });
    PageCollection.prototype.noPagination = function () {
        return this.setCurrentPage(null).setPerPage(null);
    };
    /**
     * @deprecated Use noPagination instead
     */
    PageCollection.prototype.whole = function () {
        return this.setCurrentPage(null).setPerPage(null);
    };
    PageCollection.prototype.setSearch = function (val) {
        this.search = val;
        return this;
    };
    PageCollection.prototype.setCurrentPage = function (val) {
        this.currentPage = val;
        return this;
    };
    PageCollection.prototype.setPerPage = function (val) {
        this.perPage = val;
        return this;
    };
    PageCollection.prototype.setOrderBy = function (val) {
        this.orderBy = val;
        return this;
    };
    PageCollection.prototype.setAsc = function (val) {
        this.asc = val;
        return this;
    };
    PageCollection.prototype.queryAsPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.$action
                            .query(this.params)
                            .name(this.spinnerName)
                            .as(this)
                            .getResponse()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PageCollection.prototype.querySearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.search || !this.search.length || this.search.length >= PageCollection_1.defaultMinCharToSearch)) return [3 /*break*/, 2];
                        this.currentPage = 0;
                        return [4 /*yield*/, this.queryAsPage()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    PageCollection.prototype.queryOrderBy = function (column) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.orderBy === column) {
                            this.asc = !this.asc;
                        }
                        else {
                            this.asc = true;
                        }
                        this.orderBy = column;
                        return [4 /*yield*/, this.queryAsPage()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PageCollection.prototype.queryCurrentPage = function (val) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (val > this.lastPage) {
                            this.currentPage = this.lastPage;
                        }
                        else if (val < 0) {
                            this.currentPage = 0;
                        }
                        else
                            this.currentPage = val;
                        return [4 /*yield*/, this.queryAsPage()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PageCollection.prototype.queryPrevPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.currentPage !== null && this.currentPage > 0)) return [3 /*break*/, 2];
                        this.currentPage--;
                        return [4 /*yield*/, this.queryAsPage()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    PageCollection.prototype.queryNextPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.currentPage !== null && this.currentPage < this.lastPage)) return [3 /*break*/, 2];
                        this.currentPage++;
                        return [4 /*yield*/, this.queryAsPage()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    var PageCollection_1;
    PageCollection.defaultMinCharToSearch = 3;
    PageCollection.defaultCurrentPage = 0;
    PageCollection.defaultPerPage = 20;
    __decorate([
        RequestExpose('query'),
        __metadata("design:type", Object)
    ], PageCollection.prototype, "search", void 0);
    __decorate([
        RequestExpose('page'),
        __metadata("design:type", Object)
    ], PageCollection.prototype, "currentPage", void 0);
    __decorate([
        RequestExpose('limit'),
        __metadata("design:type", Object)
    ], PageCollection.prototype, "perPage", void 0);
    __decorate([
        RequestExpose('orderBy'),
        __metadata("design:type", Object)
    ], PageCollection.prototype, "orderBy", void 0);
    __decorate([
        RequestExpose('ascending'),
        __metadata("design:type", Object)
    ], PageCollection.prototype, "asc", void 0);
    __decorate([
        Type(function (options) { return options.newObject.classType; }),
        ResponseExpose('items'),
        __metadata("design:type", Array)
    ], PageCollection.prototype, "items", void 0);
    __decorate([
        ResponseExpose('total'),
        __metadata("design:type", Object)
    ], PageCollection.prototype, "total", void 0);
    PageCollection = PageCollection_1 = __decorate([
        HttpExclude(),
        __metadata("design:paramtypes", [Object])
    ], PageCollection);
    return PageCollection;
}(ResourceCollection));
export { PageCollection };
//# sourceMappingURL=PageCollection.js.map